import styled from "styled-components";
const waveBottom = `${process.env.REACT_APP_STORAGE_ZAIA_RESOURCES}/zaiaDecorators/curva-pequena-botton-violeta.svg`;

export const GenerativeAI = styled.div`
  display: flex;
  height: 100%;
  background-color: #efeff9;
  /* background-image: url(${waveBottom}); */
  background-repeat: no-repeat;
  background-position: bottom;
  background-position-y: 125%;
  border-radius: 14px 14px 0px 0px;
  overflow: hidden;
  box-shadow: 0px 0px 29px -10px rgba(35, 34, 157, 0.1);
  .chatbot__pop-up {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    overflow: hidden;
    z-index: 1000;
    display: flex;
    flex-direction: column;
  }
  .partition-selected {
    width: 39px;
    display: flex;
    padding: 10px 10px 10px 10px;
    justify-content: center;
    align-items: center;
    &__container {
      display: flex;
      align-items: center;
      transform: rotate(-90deg);
    }
    &__point {
      width: 21px;
      height: 21px;
      border-radius: 17px;
      background: #9393ff;
      margin-right: 10px;
    }
    &__text {
      color: #1f1f52;
      font-family: "Nunito Sans";
      font-size: 14px;
      white-space: nowrap;
    }
  }
  .chatbot {
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;
  }
  .chatbot-content {
    flex: 1;
    border-radius: 14px 14px 0px 0px;
    background: #fff;
    overflow-y: auto;
  }
  .chatbot-selectors {
    display: flex;
    flex-direction: column;
    .patient-selector {
      height: 58px;
      max-width: 331px;
      margin: 20px auto 10px;
      padding: 10px;
      display: flex;
      align-items: center;
      text-align: center;
      justify-content: center;
      border-radius: 14px;
      /* border: 1px solid #C3C3E1; */
      background: linear-gradient(
        44deg,
        rgba(214, 214, 246, 0.23) 9.33%,
        rgba(79, 79, 255, 0) 235.78%
      );
      -webkit-box-shadow: -2px 2px 2px -1px #c3c3e1;
      -moz-box-shadow: -2px 2px 2px -1px #c3c3e1;
      box-shadow: -2px 2px 2px -1px #c3c3e1;
      cursor: pointer;
      &__box-icon {
        filter: drop-shadow(0px 0px 4.015px rgba(172, 172, 207, 0.45));
        border-radius: 50%;
        background-color: #fff;
        padding: 3px;
        display: flex;
        margin-right: 10px;
      }
      &__icon {
        border-radius: 50%;
      }
      &__text {
        color: #1f1f52;
        text-align: center;
        font-family: "Nunito Sans";
        font-size: 14px;
      }
    }

    .chatbot_selector {
      padding: 0px 20px 10px 20px;
      .title {
        display: flex;
        &__text {
          color: #36369b;
          font-family: "Nunito Sans";
          font-size: 14px;
          font-style: normal;
          text-align: center;
        }
        &__required {
          color: #f30c0c;
          margin-left: 5px;
        }
      }
      .input-container {
        .input-container {
          border: transparent;
          border-bottom: 1px solid #6c6bcc;
        }
      }
      .label-no-guides {
        color: red;
        font-family: "Nunito Sans";
        font-size: 12px;
      }
    }
  }

  .chatbot-container {
    box-sizing: border-box;
    padding: 0px 14px 0px 29px;
    overflow-y: scroll;
    display: flex;
    flex-direction: column;
    ::-webkit-scrollbar {
      width: 30px;
    }
    ::-webkit-scrollbar-track {
      box-shadow: inset 0 0 10px 10px transparent;
      /* margin: 1px 0px;  */
    }
    ::-webkit-scrollbar-thumb {
      border: 12px solid rgba(0, 0, 0, 0);
      box-shadow: inset 0 0 10px 10px #3e3da366;
      background-clip: padding-box;
      border-radius: 9999px;
      background-color: transparent;
    }
    &__empty {
      text-align: center;
      margin: auto;
      &-image {
      }
      &-msg {
        margin-top: 48px;
        color: #6c6bcc;
        text-align: center;
        font-family: Nunito Sans;
        font-size: 24.648px;
      }
    }
  }
`;

export const HeaderDiv = styled.div`
  .header {
    height: auto;
    padding: 9px 20px;
    box-sizing: border-box;
    align-items: center;
    overflow: hidden;
    &__top {
      display: flex;
      justify-content: space-between;
      height: auto;
      align-items: center;
    }
    &__title {
      margin: 10px 0px;
      &-logo {
        width: 180px;
        height: fit-content;
      }
    }
    &__subtitle {
      color: ${({ theme }) => theme.primaryColor};
      font-family: "Nunito Sans";
      font-size: 17px;
      color: #707582;
      display: flex;
      &-label {
        color: #1f1f52;
        margin-right: 5px;
      }
    }
    &__process-name {
      color: #1f1f52;
      font-family: "Nunito Sans";
      font-size: 14px;
      /* padding: 10px 0px; */
      display: flex;
      /* justify-content: end; */
      align-items: center;
    }
    &__process-close {
      margin-left: 5px;
      color: #36369b;
      font-size: 8px;
      border-radius: 50%;
      height: 15px;
      width: 15px;
      display: flex;
      justify-content: center;
      background-color: rgba(109, 109, 185, 0.12);
      align-items: center;
    }
    &__left {
      display: flex;
      padding: 9px 0;
      min-height: 36px;
    }
    &__info-button {
      margin-right: 10px;
    }
    &__right {
      display: flex;
      align-items: center;
      /* position: absolute; */
    }
    &__reset-button {
      display: flex;
      width: ${({ completeViewActived }) =>
        completeViewActived ? "" : "111px"};
      padding: 8.894px;
      justify-content: center;
      align-items: center;
      font-family: "Nunito Sans Bold";
      font-size: 14px;
      background: rgba(109, 109, 185, 0.12);
      cursor: pointer;
      height: fit-content;
      margin-left: 10px;
      border-radius: 15px;
      color: #36369b;
    }
    &__close-chat {
      height: fit-content;
      /* background: rgba(109, 109, 185, 0.12); */
      display: flex;
      padding: 5px;
      font-size: 10px;
      border-radius: 50%;
      cursor: pointer;
      &-icon {
        display: flex;
        /* color: ${({ theme }) => theme.primaryColor}; */
        color: #2a28d6;
      }
    }
    &__max {
      height: fit-content;
      margin-left: 10px;
      /* background: rgba(109, 109, 185, 0.12); */
      font-size: 15px;
      border-radius: 34.57px;
      cursor: pointer;
      align-items: center;
      padding: 5px;
      display: flex;
      &-icon {
        display: flex;
        /* color: ${({ theme }) => theme.primaryColor}; */
        color: #2a28d6;
      }
    }
  }
`;

export const ChatbotChooseOptions = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 97%;
  background-color: #efeff9;
  border: 2px solid #ffffff;
  bottom: 0;
  margin-top: auto;
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
  .header {
    height: 56px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 2px solid #ffffff;
    padding: 10px 20px;
    &__left {
      display: flex;
      align-items: center;
    }
    &__title {
      font-family: "Nunito Sans";
      font-weight: 400;
      font-size: 13px;
    }
    &__text {
      cursor: pointer;
      font-size: 17px;
      margin-left: 5px;
    }
    &__icon {
      cursor: pointer;
      font-size: 9px;
      padding: 5px;
    }
  }
  .view-options {
    overflow: auto;
    margin: 20px 0 20px 20px;
    overflow-y: scroll;
    ::-webkit-scrollbar {
      width: 25px;
    }
    ::-webkit-scrollbar-track {
      box-shadow: inset 0 0 10px 10px transparent;
      /* margin: 1px 0px;  */
    }
    ::-webkit-scrollbar-thumb {
      min-height: 50px;
      border: 10px solid rgba(0, 0, 0, 0);
      box-shadow: inset 0 0 10px 10px red !important;
      background-clip: padding-box;
      border-radius: 9999px;
      background-color: transparent;
    }
  }
  .view-option {
    display: flex;
    flex-direction: column;
    text-align: center;
    margin-bottom: 10px;
    &__button {
      padding: 20px;
      height: 122px;
      border-radius: 20px;
      background: #ffffff;
      display: flex;
      /* justify-content: center; */
      border: none;
      outline: none;
      font-size: 17px;
      font-style: normal;
      cursor: pointer;
      justify-content: space-between;
      align-items: center;
      &:hover {
        .view-option__button-text {
          color: #6c6bf5;
        }
        .view-option__button-icon {
          color: #6c6bf5;
        }
      }
      &-icon {
        transition: all 0.5s ease;
        font-size: 20px;
        color: #3e3e5b;
      }
      &-text-container {
        display: flex;
        flex-direction: column;
        text-align: left;
        margin-right: 70px;
      }
      &-text {
        transition: all 0.5s ease;
        font-family: "Nunito Sans Bold";
        font-size: 20px;
        color: #3e3e5b;
      }
      &-text-description {
        font-family: "Nunito Sans";
        font-size: 17px;
        color: #707582;
      }
    }
    &__description {
      margin-top: 10px;
      color: #3e3e5b;
      text-align: center;
      font-family: "Nunito Sans";
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
      text-transform: capitalize;
    }
    &:last-child {
      margin-bottom: 0px;
    }
  }
`;
